const { readsViaAgave } = require('../../tools/reads-via-agave')

// Where should `product.getByIds` read from?
//
// The raw method reads `state.productsDB`, the local integrated-data pouch. An
// online-only user never replicates it, so the read answered [] rather than
// failing, and every caller that cared had to reach for `getProductsViaIds`
// itself. Resolving it here serves all of them.
//
// - 'pouch' whenever the resolver says legacy, i.e. for everyone but an
//   online-only user, and whenever the caller passed options. `getByIds` takes
//   `{ date }` and `{ resolveAlias }`; neither the PG read nor the `by-ids`
//   endpoint can honour them, so an options read stays local.
// - 'pg' where there is a PG connection, which is the fs-api built inside
//   agave. This is also what stops the recursion: agave's own `product/by-ids`
//   handler calls `getByIds`, and resolving to PG there means it answers the
//   request rather than calling back out to the endpoint it is serving.
// - 'agave' in a browser, where there is no PG connection but there is a
//   transport to the endpoint that has one.
// - 'pouch' again with neither — a lambda or a test — so this stays safe
//   wherever the api is built.
const resolveGetByIdsSource = ({ state, options, hasPg, hasAgaveTransport }) => {
  if (options !== undefined || !readsViaAgave(state, 'product')) {
    return 'pouch'
  }

  if (hasPg) {
    return 'pg'
  }

  return hasAgaveTransport ? 'agave' : 'pouch'
}

module.exports = { resolveGetByIdsSource }
